export enum Status{
  INACTIVE = 0,
  ACTIVE = 1,
}

export enum TerminalStatus{
  INACTIVE = 2,
  ACTIVE = 1,
}


export enum ProductType
{
  Lottery = 0,
  Game = 1,
  Recharge = 2,
  Service = 3,
  InternetData = 4,
}

export enum ProductProviderCategory
{
  Communications = 0,
  Electricity = 1,
  Games = 3,
  Lottery = 4,
  Water = 5
}
